export const GoogleMapsAPI = "AIzaSyDv5zqgtn-X-lNQJoaOWwgBa_f0kpCLyDg";
